import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router';
import { LoginContext } from '../App';
import { toast, ToastContainer } from 'react-toastify';

function Login() {
  const [email,setEmail] = useState("");
  const {setLogin} = useContext(LoginContext)
  const navigate = useNavigate();
  // const [pwd,setPwd] = useState("")

  // const handleLogin = (e) => {
  //   e.preventDefault();
  //   fetch('http://localhost:1234/users')
  //   .then(res=>res.json())
  //   .then(data => { 
  //     let user = false;
  //     data.map((v,i)=> {
  //       if(v.email === email)
  //       {
  //         user = true;
  //       }
  //       return v;
  //     });
    
  //     if (user){
  //       alert("Login Successfully")
  //       navigate('/')
  //       setLogin(true)
  //     }
  //     else{
  //       alert("Invalid Credentials")
  //     }
  //   })
  // }


  const handleLogin = (e) => {
  e.preventDefault();
  
  fetch('/users.json')
    .then(res => res.json())
    .then(data => {
      // Use .find() instead of .map() for better performance
      const userFound = data.find(v => v.email === email);

      if (userFound) {
        toast.success("Login successful.", {
          position: "top-right",
          autoClose: 3000,
        });
        
        setLogin(true);
        // Delay navigation slightly so user sees the success toast
        setTimeout(() => navigate('/'), 1500); 
      } else {
        toast.error("Invalid email or password. Please try again.", {
          position: "top-right",
        });
      }
    })
    .catch(err => {
      toast.error("Server error. Please try again later.");
    });
};
  return (
    <div>
      <div>
        <div className="page-heading header-text">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                {/* <span className="breadcrumb"><a href="#">Home</a>  /  Login</span> */}
                <h3>Login</h3>
              </div>
            </div>
          </div>
        </div>
        <div className="contact-page section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-7">
                <div className="section-heading">
                  <h6>| Login</h6>
                </div>
              </div>
              <div className="col-lg-8">
                <form id="contact-form" onSubmit={handleLogin}>
                  <div className="row">
                    {/* <div className="col-lg-12">
                      <fieldset>
                        <label htmlFor="name">Full Name</label>
                        <input type="name" name="name" id="name" placeholder="Your Name..." autoComplete="on" required />
                      </fieldset>
                    </div> */}
                    <div className="col-lg-12">
                      <fieldset>
                        <label htmlFor="email">Email Address</label>
                        <input type="text" name="email" pattern="[^ @]*@[^ @]*" placeholder="Your E-mail..." value={email} onChange={(e)=>{setEmail(e.target.value)}}/>
                      </fieldset>
                    </div>
                    <div className="col-lg-12">
                      <fieldset>
                        <label htmlFor="pwd">Password</label>
                        <input type="password" placeholder="Password..." />
                      </fieldset>
                    </div>
                    <div className="col-lg-8">
                      <fieldset>
                        <button type="submit" id="form-submit" className="orange-button">Login</button>
                      </fieldset>
                    </div>
                  </div>
                </form>
                <ToastContainer />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Login
